var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-navigation'),_c('v-content',{attrs:{"id":"background","transition":"slide-x-transition"}},[_c('router-view')],1),_c('share-button'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }